var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.708 11.375H8.45801",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5834 13.7549V16.2441C26.5834 16.9087 26.0518 17.4524 25.3751 17.4766H23.0067C21.7017 17.4766 20.5055 16.522 20.3968 15.217C20.3243 14.4558 20.6142 13.7428 21.1217 13.2474C21.5688 12.7883 22.1851 12.5225 22.8617 12.5225H25.3751C26.0518 12.5466 26.5834 13.0903 26.5834 13.7549Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.122 13.2482C20.6145 13.7436 20.3245 14.4566 20.397 15.2178C20.5057 16.5228 21.702 17.4774 23.007 17.4774H25.3753V19.2295C25.3753 22.8545 22.9587 25.2712 19.3337 25.2712H8.45866C4.83366 25.2712 2.41699 22.8545 2.41699 19.2295V10.7712C2.41699 7.48449 4.39866 5.18866 7.47991 4.80199C7.79408 4.75366 8.12033 4.72949 8.45866 4.72949H19.3337C19.6478 4.72949 19.9499 4.74156 20.2399 4.78989C23.3574 5.15239 25.3753 7.46033 25.3753 10.7712V12.5233H22.862C22.1853 12.5233 21.5691 12.7891 21.122 13.2482Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.c20c9987e33f321feb10b1b7e6ea1de1.svg";
export { ForwardRef as ReactComponent };